import React from 'react'
import {TweenMax} from 'gsap'
import {connect} from 'react-redux'




class Route extends React.Component {


  constructor(props){
    super();

    let animationTime = props.animationTime || 500;

    //console.warn('Route ANIMATION TIME set to 5sec!! ')

    this.state = {
        show:false,
        componentLeaving : false,
        componentEntering : false,
        transitionActive : false,
        path:props.path,
        animationTimeout:null,
        previousLocation:'',
        active:false,
        isMounted:false,
        animationTime,
        containerHeight:null
    }

    //console.log("Route:",props);



    this.checkForLocationChange = this.checkForLocationChange.bind(this);
    this.componentRemove = this.componentRemove.bind(this);
    this.componentEnter = this.componentEnter.bind(this);
    this.componentEntred = this.componentEntred.bind(this);
    this.requestAnimFrame = this.requestAnimFrame.bind(this);

  }

  requestAnimFrame(cb){
    let  anim = window.requestAnimationFrame       ||
                  window.webkitRequestAnimationFrame ||
                  window.mozRequestAnimationFrame    ||
                  function( callback ){
                    window.setTimeout(callback, 1000 / 60);
                  };
        (this._ismounted === true)?
          anim(cb)
        : console.log("component not mounted, requestAnimFrame will not call");
    }

    checkForLocationChange(){

      console.log('Check location change');

      if(this.state.previousLocation!==window.location.pathname){
        this.checkIfActive()
        this.setState({previousLocation:window.location.pathname})
      }

      this.requestAnimFrame(this.checkForLocationChange)
    }

  componentWillUpdate(newProps,newState){
    if(newProps.route !== this.props.route){
      if(this.state.previousLocation!==window.location.pathname){
        this.checkIfActive()
        this.setState({previousLocation:window.location.pathname})
      }

    }

  }
/*
  checkBrowserPath(){
    //console.log('checkBrowserPath',(this.state.path === window.location.pathname && this.state.show===false));
    (this.state.path === window.location.pathname && this.state.show===false)?
      this.componentEnter()
    : null ;

    (this.state.path !== window.location.pathname  )?
      this.componentLeave()
    : null ;

    this.requestAnimFrame(this.checkBrowserPath);

  }
*/
  checkIfActive(){

    //console.log("Check if active");

    let locationArray = window.location.pathname.toLowerCase().split('/');

        // clean out empties
        locationArray = locationArray.filter((item,index)=>{
          return (item.length)
        })

    let pathArray = this.props.path.toLowerCase().split('/');

        // clean out empties
        pathArray = pathArray.filter((item,index)=>{
          return (item.length)
        })

        //console.log(locationArray,pathArray,this.props.to);

    let active = false;
    let matches = 0


        // Count the matches

        pathArray.map((item,index)=>{
              (locationArray[index]===item)?
                matches+=1
              : null
        });

        //console.log("Matches",matches,pathArray.length);

        // if the matches the lenth the link should be active
        (matches===pathArray.length)?
          active = true
        :  active = false ;



      //(this.props.to.toLowerCase() === window.location.pathname.toLowerCase())



      // override if the exact prop is in use

      if(this.props.exact){
        //console.log("This is an exact route", this.props.path,window.location.pathname.toLowerCase() , locationArray, pathArray);

        // remove trailing slashes.

        let path = this.props.path.replace(/\/+$/, "");
        let windowPath = window.location.pathname.replace(/\/+$/, "");

        //console.log(path,this.props.path,windowPath.toLowerCase()===path.toLowerCase());

        (path.toLowerCase()===windowPath.toLowerCase())?
          active = true
        : active = false;
      }


      (active===true && this.state.show===false)?
        this.componentEnter()
      : null ;

      (active===false)?
        this.componentLeave()
      : null ;

      (this._ismounted === true)?
        this.setState({active})
      : null;
  }

  componentEnter(){

    //console.log('Component Enter',this.props.path);
    if(this.state.show===false){
      //console.log('Animate');
      this.setState({show:true,componentEntering:true,componentLeaving:false,transitionActive:false})
      clearTimeout(this.state.animationTimeout)
      setTimeout(this.componentEntred,this.state.animationTime);

      this.requestAnimFrame(()=>{
        this.setState({transitionActive:true})
      })
    }

    // clearAnimate out

  }
  componentEntred(){
    this.setState({componentEntering:false,transitionActive:false})
  }

  componentLeave(){
    (this.state.show===true)?
      (this.state.componentLeaving===false)?
          this.componentAnimateLeave()
      : null

    : null ;
  }
  componentAnimateLeave(){


      let containerHeight = this.refs.routeContainer.clientHeight

      //console.log("containerHeight",containerHeight);


      clearTimeout(this.state.animationTimeout)
      let animationTimeout = setTimeout(this.componentRemove,this.state.animationTime);
      this.setState({componentLeaving:true,componentEntering:false,transitionActive:false,containerHeight});

      this.requestAnimFrame(()=>{
        this.setState({transitionActive:true})
      })



  }
  componentRemove(){
    (this._ismounted) && this.setState({show:false})
    //console.log('this.props.onRemoved',this.props.onRemoved);
    if(this.props.onRemoved){
      this.props.onRemoved()
    }
  }

  componentDidMount(){
    this._ismounted = true;
    this.setState({isMounted:true})
    //this.checkForLocationChange();
    this.checkIfActive()
    this.setState({previousLocation:window.location.pathname})

  }
  componentWillUnmount(){
    this._ismounted = false;
    this.setState({isMounted:false})
  }



  render() {
      //console.log('Route:',this.props);

      //console.log(window.location.pathname);


      let animationClass = '';

      (this.state.componentLeaving)?
        animationClass = ' transition-leaving'
      :(this.state.componentEntering)?
        animationClass = ' transition-entering'
      : null


      let transitionActiveClass = '';

      (this.state.transitionActive)?
          transitionActiveClass = ' transition-active'
      : null ;


      let containerStyle = {};
        /*
      (this.state.containerHeight)?
        containerStyle.maxHeight=this.state.containerHeight+'px'
      :null;

      */
      //console.log("Method to set the min height is turned off");

      if(this.state.show===false){
        return null
      }else{

      return (<div className={(animationClass)+(transitionActiveClass)} ref="routeContainer" style={containerStyle}>
                {this.props.children}
            </div>)

      }


  }
}

const mapStateToProps = (state)  => {

    //console.log(state);

    let route = state.Router.location.data


    return {
      route
    }

}

export default connect(mapStateToProps,null)(Route)



// WEBPACK FOOTER //
// ./src/modules/router/Route.js